import React from 'react';
import { useTranslation } from 'react-i18next';

// Icons
import { PiPlaceholder } from "react-icons/pi";

// Components
import Button from '../../../../components/CustomButton';
import Typography from '../../../../components/Typography';

// Styles
import styles from './style.module.scss';

// Images
import Star1 from '../../../../components/assets/star1.svg';
import Star2 from '../../../../components/assets/star2.svg';

type FieldType = 'learning_preferences' |
  'study_style' |
  'goals_motivation' |
  'learning_challenges' |
  'device_accessibility' |
  'feedback_style' |
  'emotional_state';

interface PersonalInfoRowProps {
  icon: React.ReactNode | null;
  title: string;
  description: string;
  onChange: () => void;
}

const PersonalInfoRow: React.FC<PersonalInfoRowProps> = ({ icon, title, description, onChange }) => {
  // Translations
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.subContainer}>
        <div className={styles.icon}>
          <img src={Star1} alt={title} className={styles.star1} />
          <img src={Star2} alt={title} className={styles.star2} />

          <span className={styles.iconContent}>
            {icon || <PiPlaceholder />}
          </span>
        </div>
        <div className={styles.content}>
          <Typography variant='h6' className={styles.title}>{title}</Typography>
          <Typography variant='p' className={styles.description}>{description}</Typography>
        </div>
      </div>
      <div className={styles.actions}>
        <Button variant='secondary' onClick={onChange}>
          {t('actions.change')}
        </Button>
      </div>
    </div>
  );
};

export default PersonalInfoRow;
